import { render, staticRenderFns } from "./CoursewareAudioBlock.vue?vue&type=template&id=610ae1ba&scoped=true&"
import script from "./CoursewareAudioBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareAudioBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareAudioBlock.vue?vue&type=style&index=0&id=610ae1ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610ae1ba",
  null
  
)

export default component.exports